import styled from 'styled-components'

export const WordCloudMain = styled.div`
  width: 100%;
  height: 100%;
`
